import { useState } from 'react';

import * as icons from '@creditornot/alchemy-react/icons';
import { IconButton, TextButton, TextButtonSize } from '@creditornot/cb-button';
import { IconSource } from '@creditornot/cb-ingredients';
import { Tooltip } from '@creditornot/cb-popover';

import { useFormatMessage } from '../../hooks/useFormatMessage';

type Props = {
  children: string;
  icon?: IconSource;
  textButtonSize?: TextButtonSize;
  testId?: string;
  variant?: 'text' | 'icon';
  text?: string;
  className?: string;
  ariaLabel?: string;
};

export const CopyableButton = ({
  children,
  icon,
  textButtonSize = 'small',
  testId,
  variant = 'text',
  text,
  className,
  ariaLabel,
}: Props) => {
  const f = useFormatMessage();
  const [copied, setCopied] = useState(false);

  const handleCopyText = async () => {
    await navigator.clipboard.writeText(children);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <Tooltip
      content={copied ? f('common.copied') : text || f('common.click_to_copy')}
      placement="bottom"
    >
      {variant === 'icon' ? (
        <IconButton
          size="tiny"
          variant="neutral"
          background="transparent"
          onClick={handleCopyText}
          className={className}
          icon={icon || icons.copy}
          aria-label={ariaLabel}
        />
      ) : (
        <TextButton
          size={textButtonSize}
          data-test-id={testId}
          icon={icon}
          onClick={handleCopyText}
          variant="neutral"
          className={className}
          aria-label={ariaLabel}
        >
          {children}
        </TextButton>
      )}
    </Tooltip>
  );
};
